import CompareVirtualTours from "./CompareVirtualTours";

export default CompareVirtualTours;